import { render, staticRenderFns } from "./DialogCardTitle.vue?vue&type=template&id=1947ffa2&scoped=true"
import script from "./DialogCardTitle.vue?vue&type=script&lang=js"
export * from "./DialogCardTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1947ffa2",
  null
  
)

export default component.exports